


<template>
  <div class="xialaanim"></div>
</template>
<script>
import { mapState} from "vuex";
import {

  xiaanim,
} from "../commonjs/commonfn.js";
export default {
  name: "xialaanim",
  data() {
    return {};
  },
  mounted() {
    this.xialaanim();
  },
  methods: {
    xialaanim(){
        xiaanim();
    }
  },
  computed: {
    ...mapState([
      "suodingtipcss",
      "yujiazaicss",
      "sharetipcontainercss",
      "morentanchuangcss",
      "chuangtitle",
      "fn",
      "jindu",
      "starcss",
      "isalljiazai",
      "isplaybgmusic",
    ]),
  },
};
</script>
<style scoped>
.showimg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}
.uploadinput {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/xialaanim.vue